export enum EducationLevel {
    preferNotToAnswer,
    eigthGradeOrLess,
    ninthGrade,
    tenthGrade,
    eleventhGrade,
    twelfthGrade,
    collegeFreshman,
    collegeSophomore,
    collegeJunior,
    collegeGraduate,
    masters,
    doctorate
}


// WEBPACK FOOTER //
// ./src/enums/demographics/EducationLevel.tsx